import { render } from "./DeliveryRequestCard.vue?vue&type=template&id=3209cfe0"
import script from "./DeliveryRequestCard.vue?vue&type=script&lang=js"
export * from "./DeliveryRequestCard.vue?vue&type=script&lang=js"

import "./DeliveryRequestCard.vue?vue&type=style&index=0&id=3209cfe0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__